import {
  AfterViewInit,
  Component,
  HostListener,
  Input,
  OnInit
} from '@angular/core';
import { CarouselOptions } from '../../../models/carousel-options.model';

@Component({
  selector: 'lns-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit, AfterViewInit {
  @Input() carouselOptions: CarouselOptions = {
    totalItems: 0,
    itemsPerSlide: 3,
    slideLength: 1,
    startsAt: 0,
    itemWidth: 375,
    gap: 24
  };

  child!: number;
  leftPositionPx = 0;

  getScreenWidth: any;
  getScreenHeight: any;

  ngOnInit(): void {
    this.initialPosition();
  }

  ngAfterViewInit() {
    this.onWindowResize();
    if (this.getScreenWidth > '1536') {
      this.child = 3;
    } else {
      this.child = 2;
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
  }

  initialPosition(): void {
    this.leftPositionPx = -(
      this.carouselOptions.startsAt * this.carouselOptions.itemWidth
    );
  }

  onNext(): void {
    if (
      this.carouselOptions.startsAt <
      this.carouselOptions.totalItems - this.carouselOptions.itemsPerSlide
    ) {
      this.carouselOptions.startsAt += this.carouselOptions.slideLength;
      this.leftPositionPx =
        -this.carouselOptions.startsAt * this.carouselOptions.itemWidth;
      this.child++;
    }
  }

  onPrevious(): void {
    if (this.carouselOptions.startsAt > 0) {
      this.carouselOptions.startsAt -= this.carouselOptions.slideLength;
      this.leftPositionPx =
        -this.carouselOptions.startsAt * this.carouselOptions.itemWidth;
      this.child--;
    }
  }
}
